import React from 'react';
import { Row, Col, Space, Typography, Button, Tabs } from 'antd';
import { SettingOutlined, PlusOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const ReportsLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeKey = location.pathname.startsWith('/reports/define')
    ? 'define'
    : location.pathname.startsWith('/reports/settings')
    ? 'settings'
    : 'reports';

  return (
    <div className="reports-page">
      <Row gutter={[16, 16]} align="middle">
        <Col flex="auto">
          <Space direction="vertical">
            <Title level={3}>Reports</Title>
            <Text type="secondary">Build and view saved report cards with configurable queries.</Text>
          </Space>
        </Col>
        <Col>
          <Space>
            <Button icon={<PlusOutlined />} onClick={() => navigate('/reports/define')}>
              Define
            </Button>
            <Button icon={<SettingOutlined />} onClick={() => navigate('/reports/settings')} />
          </Space>
        </Col>
      </Row>
      <Tabs
        activeKey={activeKey}
        onChange={(key) => {
          if (key === 'define') navigate('/reports/define');
          else if (key === 'settings') navigate('/reports/settings');
          else navigate('/reports');
        }}
        items={[
          { key: 'reports', label: 'Reports' },
          { key: 'define', label: 'Define Reports' },
          { key: 'settings', label: 'Settings' },
        ]}
        style={{ marginBottom: 16 }}
      />
      {children}
    </div>
  );
};

export default ReportsLayout;

